import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verif-detail',
  templateUrl: './verif-detail.component.html',
  styleUrls: ['./verif-detail.component.css']
})
export class VerifDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
